import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import styles from './KioskFeedbackLayout.styles';
// import { Paper } from '@material-ui/core';
import {
  KioskFooter,
  KioskHeader,
  KioskFeedbackMain,
  KioskIdelScreen
} from '..';

export class KioskFeedbackLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };

  handleClick = () => {
    this.props.history.push('/');
    this.props.history.push('/');
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.container)}>
        <KioskHeader />
        <KioskFeedbackMain handleClick={this.handleClick} />
        <KioskFooter customFooterBottom={'0%'} />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(KioskFeedbackLayout)
);
